import { render, staticRenderFns } from "./SlideCounter.vue?vue&type=template&id=2835c7e3&scoped=true&"
import script from "./SlideCounter.vue?vue&type=script&lang=js&"
export * from "./SlideCounter.vue?vue&type=script&lang=js&"
import style0 from "./SlideCounter.vue?vue&type=style&index=0&id=2835c7e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835c7e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2835c7e3')) {
      api.createRecord('2835c7e3', component.options)
    } else {
      api.reload('2835c7e3', component.options)
    }
    module.hot.accept("./SlideCounter.vue?vue&type=template&id=2835c7e3&scoped=true&", function () {
      api.rerender('2835c7e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/SlideCounter.vue"
export default component.exports